import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import LinkHandler from 'components/atoms/LinkHandler'
import Image from 'components/atoms/Image'
import SectionTitle from 'components/molecules/SectionTitle'

// Style
import './InfoCard.scss'

function InfoCard({
  id,
  title,
  subtitle,
  className,
  image,
  ctaText,
  url,
  icon,
  linkType,
  sectionTitle,
  theme,
  titleMaxLine,
}) {
  const ComponentInfoCard = () => (
    <div
      className={ClassNames('card info-card', className, {
        'info-card--link': url,
        [`card-${theme}`]: theme,
        'only-image': !title && !subtitle,
      })}
    >
      {image && (
        <Image
          src={image}
          title={title}
          alt={title || 'Imagem ilustrativa'}
          className={`info-card-image ${!title && !subtitle ? 'full-image' : ''}`}
        />
      )}
      {sectionTitle?.title && (
        <SectionTitle title={sectionTitle.title} className="mb-4" barColor={sectionTitle.barColor}></SectionTitle>
      )}
      {title && <p className={`info-card-title max-line-${titleMaxLine || 2}`}>{title}</p>}
      {subtitle && <p className={`info-card-subtitle mb-20`}>{subtitle}</p>}
      {url && (
        <p className="info-card-link mt-2">
          {ctaText}
          <i
            className={ClassNames({ 'ml-2': ctaText }, `icone-${icon || 'arrow-right'}`, 'info-card__icon')}
            role="presentation"
          />
        </p>
      )}
    </div>
  )

  if (url)
    return (
      <LinkHandler id={id} to={url} title={title} type={linkType}>
        <ComponentInfoCard />
      </LinkHandler>
    )
  else return <ComponentInfoCard />
}

InfoCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string,
  ctaText: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.string,
  sectionTitle: PropTypes.object,
  linkType: PropTypes.string,
  titleMaxLine: PropTypes.number,
}

export default InfoCard
